// Libraries
var React = require('react');

// Styles
require('./LiveLeagueTable.scss');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

class LiveLeagueTableModule extends React.Component {    
    render() {
        return (
            <div className="LiveLeagueTable">
                <div className="LiveLeagueTable__wrapper">
                    <div className="LiveLeagueTable__name">{this.props.table.Name}</div>
                    {this.props.table.Table.length > 0 &&
                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th className="LeagueTable__cell"><abbr title="Position">Pos</abbr></th>
                                        <th className="LeagueTable__cell">Team</th>
                                        <th className="LeagueTable__cell"><abbr title="Played">Pld</abbr></th>
                                        <th className="LeagueTable__cell"><abbr title="Win">W</abbr></th>
                                        <th className="LeagueTable__cell"><abbr title="Draw">D</abbr></th>
                                        <th className="LeagueTable__cell"><abbr title="Loss">L</abbr></th>
                                        <th className="LeagueTable__cell LeagueTable__cell--desktop"><abbr title="Goal for">GF</abbr></th>
                                        <th className="LeagueTable__cell LeagueTable__cell--desktop"><abbr title="Goal against">GA</abbr></th>
                                        <th className="LeagueTable__cell LeagueTable__cell--desktop"><abbr title="Goal difference">GD</abbr></th>
                                        <th className="LeagueTable__cell"><abbr title="Points">Pts</abbr></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.table.Table.length > 0 && this.props.table.Table.map((element, index) => {
                                        let isSpurs = this.props.siteTeamOptaId === parseInt(element.TeamRef, 10);
                                        return(
                                            <tr key={index} className={"LiveLeagueTable__row" + (isSpurs ? " LiveLeagueTable__row--highlight" : "")}>
                                                <td className="LiveLeagueTable__cell">
                                                    <div> {/* this div can have LiveLeagueTable__cell--up and LiveLeagueTable__cell--down classes when the data supports it */}
                                                        {element.Position}
                                                    </div>
                                                </td>
                                                <td className="LiveLeagueTable__cell">
                                                    <div className="LiveLeagueTable__cell--image">
                                                        <img src={PlaceholderImg} data-src={this.props.baseUrl + element.TeamRef + ".png"} alt="" />
                                                    </div>
                                                    <div className="LiveLeagueTable__cell--team">
                                                        <span className="LiveLeagueTable__cell--longname">{element.TeamName}</span>
                                                    </div>
                                                </td>
                                                <td className="LiveLeagueTable__cell">{element.Played}</td>
                                                <td className="LiveLeagueTable__cell">{element.Won}</td>
                                                <td className="LiveLeagueTable__cell">{element.Drawn}</td>
                                                <td className="LiveLeagueTable__cell">{element.Lost}</td>
                                                <td className="LiveLeagueTable__cell LeagueTable__cell--desktop">{element.GoalsFor}</td>
                                                <td className="LiveLeagueTable__cell LeagueTable__cell--desktop">{element.GoalsAgainst}</td>
                                                <td className="LiveLeagueTable__cell LeagueTable__cell--desktop">{element.GoalDifference}</td>
                                                <td className="LiveLeagueTable__cell">{element.Points}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </div>
		)
	}
}

module.exports = LiveLeagueTableModule;



// WEBPACK FOOTER //
// ./src/components/MDC/LiveResults/LiveLeagueTable/LiveLeagueTableModule.js